import UrlUtils from '@spothero/utils/url';
import { HIDE_EVENT_MODAL } from 'pages/search-transient-event-monthly/WithSearch';
import { push } from 'store/router/router-actions';
import { useDispatch } from 'react-redux';
// Testing this was confusing so I ended up not, real test is the friends we made along the way
export const useAddHideEventModal = () => {
    const dispatch = useDispatch();
    const addHideEventModal = () => {
        const queryParams = UrlUtils.parseParams(window.location.search);
        queryParams.hide_event_modal = HIDE_EVENT_MODAL.TRANSIENT;
        dispatch(push(`${window.location.pathname}?${UrlUtils.createQueryString(queryParams)}`, {
            reload: false,
        }));
    };
    return addHideEventModal;
};
